import * as React from "react";
import type { SVGProps } from "react";

interface SuspensionFiveProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SuspensionFive = ({ cancelled = false, ...props }: SuspensionFiveProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.925} fill="#FFF" rx={8.087} ry={8.143} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.986-.375a1.323 1.323 0 0 1 1.316 1.17c.007.472-.133.823-.348 1.072a1.26 1.26 0 0 1-.968.442l-.38.52a9.88 9.88 0 0 1 6.141 3.083 9.73 9.73 0 0 1 2.628 6.66 9.74 9.74 0 0 1-2.893 6.933 9.88 9.88 0 0 1-6.982 2.87 9.88 9.88 0 0 1-6.982-2.87A9.74 9.74 0 0 1-.375 12.57c0-2.57.997-4.91 2.628-6.659a9.88 9.88 0 0 1 6.141-3.083v-.52c-.746 0-1.077-.148-1.317-.388A1.32 1.32 0 0 1 6.69.984c0-.382.147-.717.38-.958.241-.25.575-.401.945-.401zM9.5 4.968a7.67 7.67 0 0 0-5.42 2.228 7.55 7.55 0 0 0-2.243 5.375c0 2.1.857 4 2.243 5.376a7.67 7.67 0 0 0 5.42 2.227 7.67 7.67 0 0 0 5.42-2.227 7.55 7.55 0 0 0 2.243-5.376c0-2.099-.857-4-2.243-5.375A7.67 7.67 0 0 0 9.5 4.968Z"
        />
      </g>
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="M11.798 19.09a3.615 3.615 0 0 1-2.4-.93q-.375-.345-.323-.705t.413-.585q.375-.24.675-.158.3.083.675.353.21.15.442.232.233.083.518.083.795 0 1.177-.465.383-.465.383-1.305 0-.945-.338-1.335-.337-.39-.907-.39-.345 0-.63.12-.345.18-.593.352-.248.173-.637.173-.915 0-.915-.99V9.49q0-.99.99-.99h3.45q.99 0 .99.81 0 .825-.99.825h-2.655v2.46a1.8 1.8 0 0 1 1.035-.345q.84 0 1.515.367t1.08 1.11.405 1.883q0 1.665-.923 2.573t-2.437.907"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SuspensionFive;
